import React, { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { ProjectTemplateList } from './ProjectTemplateList'
import { customProjectTemplatesMapSelector } from '../../../common/src/selectors/projectTemplatesSelectors'
import { getCustomProjectTemplates } from '../../../common/src/actions/projectTemplatesAPI'
import { customProjectTemplateHelper } from '../../../common/src/helpers'
import { useFetch } from '../../../common/src/hooks/networkingHooks'
import { PROJECT_TEMPLATE_TYPE } from '../ProjectTemplateType'

const type = PROJECT_TEMPLATE_TYPE.CUSTOM

export const CustomProjectTemplateList = ({ ...rest }) => {
  const dispatch = useDispatch()
  const templates = useSelector(customProjectTemplatesMapSelector)
    .sortBy(customProjectTemplateHelper.sortDescriptorByName)
    .toArray()

  const fetchTemplates = useCallback(async () => dispatch(getCustomProjectTemplates()), [dispatch])
  const { loading } = useFetch(fetchTemplates)

  return <ProjectTemplateList type={type} templates={templates} loading={loading} {...rest} />
}
